export default {
  "main": {
    "login": "Iniciar sessão",
    "email": "E-mail",
    "password": "Senha",
    "loginButton": "Inicia Sessão",
    "developedBy": "Desenvolvido por",
    "error": "Usuário ou senha incorreta",
    "sessionExpired": "Sua sessão finalizou automáticamente, por favor ingresse suas credenciais de acesso novamente.",
    "sessionExpiredTitle": "Sessão expirada",
    "next": "Próxima",
    "emailRequired": "O e-mail é obrigatório",
    "passwordRequired": "Senha requerida",
    "validating": "Validando ...",
    "back": "Voltar",
    "loading": "Carregando",
    "errorGetUrlSSO": "Não foi possível obter url de Auth0 para fazer login. Entre em contato com o Help Desk da Gauss Control.",
    "errorLoginlSSO": "Não foi possível fazer login com a autenticação Auth0. Tente novamente e, se o problema persistir, entre em contato com o help desk da Gauss Control.",
    "backToLogin": "Volte ao login",
    "redirectTitleError": "Página não dísponivel",
    "redirectMessageError": "Não foi possível realizar o redirecionamento da url consultada"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/login/index.js